import { c as _c } from "react/compiler-runtime";
/* eslint-disable @next/next/no-img-element */
import type { ReasonForVisitIconProps } from "./reason-for-visit.types";
import styles from "./ReasonForVisit.module.css";
export const MottoAligners = t0 => {
  const $ = _c(6);
  const {
    width,
    height
  } = t0;
  let t1;
  if ($[0] !== height || $[1] !== width) {
    t1 = {
      width,
      height
    };
    $[0] = height;
    $[1] = width;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <img src="/assets/aspenmarketing/svgs/motto-aligners.svg" alt="Motto Aligners Icon" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className={`${styles.reasonForVisitIcon} ${styles.reasonForVisitIconMotto}`} style={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};